import React, { memo, useMemo, useRef } from 'react';
import { Section } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { lowerBoundsBreakpoints, strictBreakpoints } from 'common/styles/breakpoints';
import {
  complexCards,
  cardColumnOne,
  cardColumnTwo,
  cardImage,
} from './complex-cards-styles';

export type ComplexCardStructure = {
  srcLd: string;
  srcT: string;
  src: string;
  alt: string;
  title: string;
}

type TProps = {
  cards: ComplexCardStructure[];
  elementBlock: string;
}

export const ComplexCards: React.FC<TProps> = memo(({ cards, elementBlock }) => {
  const cardRefs = useRef<HTMLPictureElement[]>([]);
  const promotions = useMemo(() => cards.map(({ title }: ComplexCardStructure, index: number) => ({
    name: elementBlock,
    creative: title,
    position: (index + 1).toString(),
  })), [elementBlock, cards]);

  usePromoViewEvent(cardRefs, elementBlock, promotions);

  const [firstCard, secondCart, thirdCard] = cards;

  return (
    <Section>
      <div className={complexCards}>
        <div className={cardColumnOne}>
          <picture
            data-position={0}
            ref={(el: HTMLDivElement | null) => {
              if (el && cardRefs) cardRefs.current[0] = el;
            }}
          >
            <source srcSet={firstCard.srcLd} media={lowerBoundsBreakpoints['--from-desktop']} />
            <source srcSet={firstCard.srcT} media={strictBreakpoints['--only-tablet']} />
            <img
              alt={firstCard.alt}
              className={cardImage}
              src={firstCard.src}
            />
          </picture>
        </div>
        <div className={cardColumnTwo}>
          <picture
            data-position={1}
            ref={(el: HTMLPictureElement | null) => {
              if (el && cardRefs) cardRefs.current[1] = el;
            }}
          >
            <source srcSet={secondCart.srcLd} media={lowerBoundsBreakpoints['--from-desktop']} />
            <source srcSet={secondCart.srcT} media={strictBreakpoints['--only-tablet']} />
            <img
              alt={secondCart.alt}
              className={cardImage}
              src={secondCart.src}
            />
          </picture>
          {
            thirdCard && (
              <picture
                data-position={2}
                ref={(el: HTMLPictureElement | null) => {
                  if (el && cardRefs) cardRefs.current[2] = el;
                }}
              >
                <source srcSet={thirdCard.srcLd} media={lowerBoundsBreakpoints['--from-desktop']} />
                <source srcSet={thirdCard.srcT} media={strictBreakpoints['--only-tablet']} />
                <img
                  alt={thirdCard.alt}
                  className={cardImage}
                  src={thirdCard.src}
                />
              </picture>
            )
          }
        </div>
      </div>
    </Section>
  );
});
